import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';
import { UsuarioFise } from 'src/app/shared/model/security/userbean.model';
import swal from 'sweetalert2';
import { FiseService } from '../../fise.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatError, MatLabel } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'app-modal-usuario',
    standalone: true,
    templateUrl: './modal-usuario.component.html',
    styleUrls: ['./modal-usuario.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatLabel, NgIf, MatError, MatRadioGroup, MatRadioButton, MatDialogActions, MatButton]
})
export class ModalUsuarioComponent implements OnInit {
  formGroupUsuario: FormGroup;
  objectUusuario: UsuarioFise;
  tituloOperacion: string;
  usuarioDuplicado: boolean = false;

  constructor(public modalDialog: MatDialogRef<ModalUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public usuarioEdit: UsuarioFise,
    private formBuildier: FormBuilder, private usuarioService: FiseService,private aplicacionService: FiseService,
    private cdref: ChangeDetectorRef) { }
    taskTypeAreas:any[];
    selectedOptions: any[];
    get formUsuar() {return this.formGroupUsuario.controls;}
  ngOnInit() {
     if(this.usuarioEdit.id == null){
       this.tituloOperacion = "Alta";
     }else{
       this.tituloOperacion ="Edición";
     }
     this.objectUusuario = this.usuarioEdit;
    this.formGroupUsuario = this.formBuildier.group({
      controlNUsuario: ['', Validators.required],
      controlDesc: ['',[]],
      controlPrivilegios: ['', Validators.required],
      controlPass: ['', [Validators.required]],
  });
  }

  onClicCerrarModal(): void {
    this.modalDialog.close();
  }
  onClicGuardar(): void {

    var usuarioreq = new UsuarioFise();
    usuarioreq.id_Aplicacion=this.objectUusuario.id_Aplicacion;
    usuarioreq.usuario=this.objectUusuario.usuario;
    this.aplicacionService.contarUsuarioDuplicadoPorApp(usuarioreq).subscribe(res =>{
      console.log(res.pTotalItems+ " Usuarios Duplicados");

      if(res.pTotalItems === 0){
        this.usuarioService.GuaradarOActualizarUsuario(this.objectUusuario).subscribe(response => {
          console.log(this.objectUusuario);
          
              if(response.pCodRetorno === '00000')
              
              this.modalDialog.close(response.pCodRetorno);
            swal.fire({
              title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
              text: response.pMensaje,
              buttonsStyling: false,
              customClass:{
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-info',
              },
              confirmButtonText: 'Aceptar',
              icon: response.pCodRetorno === '00000' ? 'success' : 'warning'
            })
        });


      }else{
        console.log( "Usuario Duplicado");
        this.usuarioDuplicado = true;
        swal.fire({
          title: 'ERROR',
          text: 'El nombre de usuario que desea ingresar ya existe',
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-info',
          },
          confirmButtonText: 'Aceptar',
          icon: 'warning'
        });
        
        return;
        
      }
      
    });
  }

}
